import React, {Component} from 'react';
import {Col, Button, Row, Card, CardBody, ButtonToolbar} from 'reactstrap';
import Alert from '../../../components/Alert';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import * as http from '../../../modules/http';
import * as environment from "../../../modules/environment";
import * as TextManager from "../../../modules/languages/TextManager";
import {eq_item_update_field, eq_item_update} from '../../../redux/actions/EquipmentActions';


class EditEquipmentStoreItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            saved: false
        }
    }

    saveItem = () => {
        this.setState({saving: true, error: false, warning: ''});

        const itemData = {
            serial: this.props.itemEquipInEdit.serial,
            count: parseInt(this.props.itemEquipInEdit.count),
            name: this.props.itemEquipInEdit.name,
            text: this.props.itemEquipInEdit.text
        };

        http.postToServer(
            'equip/equip_item_update',
            itemData,
            (response) => {
                this.setState({saving: false, error: false});

                this.props.dispatch(eq_item_update(response.data));

                this.props.onClose();
            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})
            }
        );

    };

    render() {

        //console.log(this.props.itemEquipInEdit);

        return (
            <Row>
                {this.state.warning !== '' &&
                <Col sm={12} md={12} xs={12} lg={12}>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span
                            className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                        </p>
                    </Alert>
                </Col>
                }

                <Col>
                    <Card>
                        <CardBody style={{boxShadow: 'none'}}>
                            <div className='card__title'>
                                <h5 className='bold-text'>תמונה</h5>
                            </div>
                            <div>
                                <img className="catalog-item__img" style={{objectFit: 'contain'}}
                                     src={environment.getServerBasePath() + '/equip/equip_serial_download?serial=' + this.props.itemEquipInEdit.serial}
                                     alt="catalog-item-img"/>
                            </div>
                        </CardBody>
                    </Card>
                </Col>

                <Col md={7}>
                    <Card>
                        <CardBody style={{boxShadow: 'none'}}>
                            <div className='card__title'>
                                <h5 className='bold-text'>{"הוסף כמות ציוד"}</h5>
                            </div>
                            <form className='form form--horizontal'>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>כמות</label>
                                    <div className='form__form-group-field'>
                                        <input
                                            dir={"auto"}
                                            value={this.props.itemEquipInEdit.count}
                                            onChange={(event) => this.props.dispatch(eq_item_update_field("count", event.target.value))}
                                        />
                                    </div>
                                </div>

                                <div className='form__form-group'>
                                    <ButtonToolbar className="form__button-toolbar">
                                        <Button color="primary" onClick={() => this.saveItem()}>שמור</Button>
                                        <Button type="button" onClick={() => this.props.onClose()}>ביטול</Button>
                                    </ButtonToolbar>
                                </div>

                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        itemEquipInEdit: state.equipment.itemEquipInEdit,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(EditEquipmentStoreItem))